import B2BReviewSection from "@/containers/Home/B2BReviewSection";
// import BenefitFirstSection from "@/containers/Home/BenefitFirstSection";
import BenefitFourthSection from "@/containers/Home/BenefitFourthSection";
import BenefitSecondSection from "@/containers/Home/BenefitSecondSection";
import BenefitThirdSection from "@/containers/Home/BenefitThirdSection";
import B2BCollaborationSection from "@/containers/Home/B2BCollaborationSection";
import HeroSection from "@/containers/Home/HeroSection";
import ReviewSection from "@/containers/Home/ReviewSection";

import { VStack } from "goi_common";
import TrustSection from "@/containers/Home/TrustSection";
import CollaborationSection from "@/containers/Home/CollaborationSection";
import PRSection from "@/containers/Home/PRSection";
import Footer from "@/containers/Home/Footer";
import B2BServiceDownloadSection from "@/containers/Home/B2BServiceDownloadSection";

export default function Index() {
  return (
    <VStack width="100%">
      <HeroSection />
      <B2BCollaborationSection />
      <B2BReviewSection />
      <ReviewSection />
      <B2BServiceDownloadSection />
      {/* <BenefitFirstSection /> */}
      <BenefitSecondSection />
      <BenefitThirdSection />
      <BenefitFourthSection />
      <TrustSection />
      <CollaborationSection />
      <PRSection />
      <Footer />
    </VStack>
  );
}
